import { constant } from '@medflex/commons';

const isDemoPatient = ({ id }) => id.startsWith(constant.demoPatient.idPrefix);

export default isDemoPatient;
